import React, { Component } from 'react';

import {
  LineChart,
  Line,
  XAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid
} from 'recharts';

class MiniGraph extends Component {

  render() {
    const CustomTooltip1 = ({ active, payload }) => {
      const real = this.props.dataKey2;

      if (active && payload) {
        return (
          <div className="custom-tooltip">
            <p className="label">{payload[0] ? payload[0].dataKey === 'ontimeperformance' ?
              payload[0].payload[real].toLocaleString('fr-CA') + '%' :
              payload[0].payload[real].toLocaleString('fr-CA') : 'ND'}</p>
          </div>
        );
      }
    };

    const CustomTooltip2 = ({ active, payload }) => {
      const planned = this.props.dataKey1;
      const real = this.props.dataKey2;
      if (active && payload) {
        return (
          <div className="custom-tooltip">
            <p className="label">{this.props.name1} : <br />{payload[0] ? payload[0].payload[planned] ? payload[0].payload[planned].toLocaleString('fr-CA') : 'ND' : 'ND'}<br />
              {this.props.name2} : <br />{payload[0] ? payload[0].payload[real] ? payload[0].payload[real].toLocaleString('fr-CA') : 'ND' : 'ND'}<br />
              % {this.props.name1}/{this.props.name2} : <br />{payload[0] ? Math.round(payload[0].payload[real] / payload[0].payload[planned] * 100) : 'ND'} %</p>
          </div>
        );
      }

      return null;
    };

    return (
      <div className="col-xl-2 col-lg-4 col-md-4 col-6 chart-col">
        <div className="chart-panel">
          <div className="chart-panel__title">{this.props.kpi}</div>
          <ResponsiveContainer width="100%" height={280}>
            <LineChart
              data={this.props.data}
              margin={{ left: 24, right: 24, bottom: 10, top: 8 }}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
              <Line
                type="monotone"
                dataKey={this.props.dataKey2}
                stroke="#770066"
                strokeWidth={2}
                dot={{ r: 2, fill: '#770066' }}
                name={this.props.name2}
                isAnimationActive={false}
              />
              {this.props.dataKey1 !== '' ? (
                <Line
                  type="monotone"
                  dataKey={this.props.dataKey1}
                  stroke="#94a3b8"
                  strokeWidth={2}
                  strokeDasharray="5 4"
                  dot={{ r: 2, fill: '#94a3b8' }}
                  name={this.props.name1}
                  isAnimationActive={false}
                />
              ) : null}
              <XAxis
                dataKey={this.props.xAxisKey}
                angle={-90}
                dx={-4}
                textAnchor="end"
                interval={0}
                height={80}
                tick={{ fill: '#64748b', fontSize: 11 }}
                axisLine={{ stroke: '#e2e8f0' }}
              />
              <Tooltip content={this.props.dataKey1 !== '' ? <CustomTooltip2 /> : <CustomTooltip1 />} />
              <Legend formatter={(value) => <span className="chart-legend-label">{value}</span>} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default MiniGraph;
